/**
 * يحوّل الأرقام العربية والفارسية (٠١٢… / ۰۱۲…) إلى 0123456789.
 */
export function toWesternDigits(value: string): string {
  return value.replace(/[\u0660-\u0669\u06F0-\u06F9]/g, (ch) => {
    const c = ch.charCodeAt(0);
    if (c >= 0x0660 && c <= 0x0669) return String(c - 0x0660);
    if (c >= 0x06f0 && c <= 0x06f9) return String(c - 0x06f0);
    return ch;
  });
}
